export default "__VITE_ASSET__DbZgy$nM__"